// "Import layout" button + wizard, mounted in the SiteLayout tab strip.
// On commit it invalidates the whole site subtree (devices + floors +
// per-floor areas), since an import can create floors, areas, AND devices.

import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { qk } from "../../api/queryKeys";

import { LayoutImportModal } from "./LayoutImportModal";

interface LayoutImportButtonProps {
  accountSlug: string;
  tenantSlug: string;
  siteSlug: string;
}

export function LayoutImportButton({
  accountSlug,
  tenantSlug,
  siteSlug,
}: LayoutImportButtonProps) {
  const [open, setOpen] = useState(false);
  const queryClient = useQueryClient();

  return (
    <>
      <button type="button" style={btn} onClick={() => setOpen(true)}>
        Import layout
      </button>
      <LayoutImportModal
        accountSlug={accountSlug}
        tenantSlug={tenantSlug}
        siteSlug={siteSlug}
        open={open}
        onClose={() => setOpen(false)}
        onCommitted={() => {
          // Invalidate the whole site subtree — site detail, floors,
          // per-floor areas, and devices all share the qk.site prefix, so
          // a single prefix invalidation refetches every affected list.
          queryClient.invalidateQueries({
            queryKey: qk.site(accountSlug, tenantSlug, siteSlug),
          });
        }}
      />
    </>
  );
}

const btn: React.CSSProperties = {
  background: "var(--accent)",
  color: "var(--bg)",
  border: "none",
  padding: "6px 12px",
  borderRadius: 4,
  fontSize: "0.82rem",
  fontWeight: 600,
  cursor: "pointer",
};
